






































import {
    Component,
    Prop,
    Vue,
    VueComponent,
    InjectComponent,
    FlowStep,
    ComponentStyleDefinition,
    ComponentStyle,
    FilterPanelSettings,
} from "@zoovu/runner-browser-api";
import { FiltersSettings } from './types';

@Component({})
export default class FilterPanelView extends Vue {

    @Prop()
    filter: FlowStep;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("FilterQuestionView")
    filterQuestion: VueComponent;

    expandedAll = Boolean(this.filterSettings.expandAllByDefault);

    infoTextShown = false;

    get filterSettings(): FilterPanelSettings {
        return this.filter.filterSettings ? this.filter.filterSettings : {};
    }

    get toggleAllButtonText(): string {
        return this.expandedAll ? "message-filter-collapse-all" : "message-filter-expand-all";
    }

    get displayRestartFiltersButton(): boolean {
        return !!this.filterSettings[FiltersSettings.SHOW_RESET_OPTION];
    }

    get displayExpandAllButton(): boolean {
        return !!this.filterSettings[FiltersSettings.SHOW_EXPAND_ALL_BUTTON];
    }

    onResetFilters(): void {
        this.$emit("reset-filters-click");
    }

    toggleExpandAll(): void {
        this.expandedAll = !this.expandedAll;
    }

    showInfoText(): void {
        this.infoTextShown = true;
    }

    hideInfoText(): void {
        this.infoTextShown = false;
    }
}
